import desktopAds from './injectDesktopAds';

export default [
  ...desktopAds,
];
